import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export default {
  data: function data() {
    return {
      searchForm: {
        ps: 20,
        pn: 1,
        isOpen: 1
      },
      // 搜索表单
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 表单
      form: {},
      dialogVisible: false,
      // 弹窗状态
      cityList: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getCityList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    deleteItem: function deleteItem(row) {
      var _this2 = this;
      this.$confirm("删除该订单， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.deleteVipOrder({
                id: row.id
              });
            case 1:
              _this2.$message.success("操作成功");
              _this2.getData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))).catch(function () {});
    },
    getCityList: function getCityList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.getCityList({
                isOpen: 1,
                ps: 100
              });
            case 1:
              res = _context3.v;
              _this3.cityList = res.data.list;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (type === "search") {
                _this4.searchForm.pn = 1;
              }
              _this4.tableLoading = true;
              _context4.n = 1;
              return _this4.$api.getVipOrderList(_this4.searchForm);
            case 1:
              res = _context4.v;
              _this4.tableData = res.data.list;
              _this4.total = res.data.count;
              _this4.tableLoading = false;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    updateDialog: function updateDialog(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    save: function save() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!_this5.form.id) {
                _context5.n = 2;
                break;
              }
              _context5.n = 1;
              return _this5.$api.updateVipOrder(_this5.form);
            case 1:
              _context5.n = 3;
              break;
            case 2:
              _context5.n = 3;
              return _this5.$api.addVipOrder(_this5.form);
            case 3:
              _this5.dialogVisible = false;
              _this5.form = {};
              _this5.getData();
            case 4:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    }
  }
};